import { getIntlNumberFormat } from '../intl/number';

const getNoOpFormatter = (locale: string = 'default', options: Intl.NumberFormatOptions = {}) => {
  const { currency: _c, style: _s, ...rest } = options || {};
  const baseFormatter = getIntlNumberFormat(locale, rest);

  return {
    format: (x: number | bigint | undefined) => x?.toString() || '',
    formatToParts: (x: number | bigint | undefined) => [{ type: 'unknown' as Intl.NumberFormatPartTypes, value: x?.toString() || '' }],
    resolvedOptions: baseFormatter.resolvedOptions,
    formatRange: baseFormatter.formatRange,
    formatRangeToParts: baseFormatter.formatRangeToParts,
  };
};

export const getCurrencyFormatter = (locale: string = 'default', options: Intl.NumberFormatOptions = {}): Intl.NumberFormat => {
  try {
    return getIntlNumberFormat(locale, { ...options, style: 'currency' });
  } catch {
    if (options?.style === 'currency' && options?.currency) {
      const rootFormatter = getIntlNumberFormat(locale, {
        ...options,
        currency: 'BTC',
      });

      return {
        ...rootFormatter,
        format: (x: number | bigint | undefined) =>
          rootFormatter
            .formatToParts(x)
            .map((part) => (part.type === 'currency' ? options.currency : part.value))
            .join(''),
        formatToParts: (x: number | bigint | undefined) =>
          rootFormatter.formatToParts(x).map((part) =>
            part.type === 'currency'
              ? ({
                  ...part,
                  value: options.currency,
                } as Intl.NumberFormatPart)
              : part,
          ),
        formatRange: (x: number | bigint, y: number | bigint) =>
          rootFormatter
            .formatRangeToParts(x, y)
            .map((part) => (part.type === 'currency' ? options.currency : part.value))
            .join(''),
        formatRangeToParts: (x: number | bigint, y: number | bigint) =>
          rootFormatter.formatRangeToParts(x, y).map((part) =>
            part.type === 'currency'
              ? ({
                  ...part,
                  value: options.currency,
                } as Intl.NumberRangeFormatPart)
              : part,
          ),
      } as Intl.NumberFormat;
    }

    return getNoOpFormatter(locale, options) as Intl.NumberFormat;
  }
};
